import React from "react";
import { complianceColor, MiniBar } from "./stpHelpers";

const PARAMS = [
  { key: "ph",            label: "pH",               value: null, unit: "",      minLim: 6.5, maxLim: 8.5  },
  { key: "tds",           label: "TDS",              value: null, unit: "mg/L",  maxLim: 2100             },
  { key: "turbidity",     label: "Turbidity",        value: null, unit: "NTU",   maxLim: 10               },
  { key: "bod",           label: "BOD",              value: null, unit: "mg/L",  maxLim: 20               },
  { key: "cod",           label: "COD",              value: null, unit: "mg/L",  maxLim: 100              },
  { key: "tss",           label: "TSS",              value: null, unit: "mg/L",  maxLim: 30               },
  { key: "residualChlorine", label: "Residual Cl₂",  value: null, unit: "mg/L",  minLim: 0.2, maxLim: 1.5 },
];

const StpOutletPanel = ({ d }) => {
  const { outlet } = d;
  const maxPh = Math.max(...outlet.hourlyPh.map(x => x.ph), outlet.limits.ph.max);

  return (
    <div className="stp-outlet-panel">

      {/* Compliance header */}
      <div className={`stp-outlet-compliance-banner ${outlet.compliance === "Compliant" ? "stp-comp-banner-ok" : "stp-comp-banner-fail"}`}>
        <span>{outlet.compliance === "Compliant" ? "✅" : "❌"}</span>
        <div>
          <div className="stp-ocb-title">Outlet: {outlet.compliance}</div>
          <div className="stp-ocb-sub">All parameters within MPCB / CPCB discharge limits</div>
        </div>
        <div className="stp-ocb-flow">Flow: {outlet.flowRate} m³/hr</div>
      </div>

      {/* Parameter cards */}
      <div className="stp-outlet-params">
        {PARAMS.map(p => {
          const val = outlet[p.key];
          if (val == null) return null;
          const col = complianceColor(val, p.minLim, p.maxLim);
          const pct = p.maxLim ? (val / p.maxLim) * 100 : ((val - p.minLim) / (p.maxLim - p.minLim)) * 100;
          const status = col === "#10b981" ? "Within limit" : col === "#f59e0b" ? "Near limit" : "VIOLATION";
          return (
            <div key={p.key} className="stp-op-card" style={{ borderTopColor: col }}>
              <div className="stp-op-val" style={{ color: col }}>{val}<span className="stp-op-unit"> {p.unit}</span></div>
              <div className="stp-op-label">{p.label}</div>
              <div className="stp-op-limit">Limit: {p.minLim ? `${p.minLim}–` : ""}{p.maxLim} {p.unit}</div>
              <div style={{ marginTop: 6 }}><MiniBar value={Math.min(val, p.maxLim || 10)} max={p.maxLim || 10} color={col} height={6} /></div>
              <span className="stp-badge" style={{ background: col + "18", color: col, marginTop: 4, fontSize: 10 }}>{status}</span>
            </div>
          );
        })}
      </div>

      {/* Hourly pH trend */}
      <div className="stp-chart-card" style={{ marginTop: 16 }}>
        <div className="stp-section-title">Outlet pH — Last 12 Hours (Limit: 6.5–8.5)</div>
        <div className="stp-do-chart">
          {outlet.hourlyPh.map((pt, i) => {
            const col = pt.ph > 8.5 || pt.ph < 6.5 ? "#ef4444" : pt.ph > 8.0 ? "#f59e0b" : "#10b981";
            return (
              <div key={i} className="stp-do-col">
                <div className="stp-do-bar-wrap">
                  <div className="stp-do-bar" style={{ height: `${((pt.ph - 6) / 3) * 100}%`, background: col }} />
                </div>
                <div className="stp-do-val" style={{ color: col, fontSize: 9 }}>{pt.ph}</div>
                <div className="stp-do-lbl">{pt.t.replace(":00","")}</div>
              </div>
            );
          })}
        </div>
        <div className="stp-limit-lines">
          <span style={{ color: "#ef4444" }}>Upper limit: 8.5</span>
          <span style={{ color: "#ef4444" }}>Lower limit: 6.5</span>
        </div>
      </div>

      <div className="stp-ai-strip">
        🤖 AI: Outlet pH trending from 7.2 → 7.6 over 6 hours. If trend continues, pH will breach 8.5 limit in ~14 hours. Pre-emptive acid dosing recommended.
      </div>
    </div>
  );
};

export default StpOutletPanel;
